/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// import * as ds from 'deepstream.io-client-js'


import ordersList from './orders' // модуль для работы с таблицей заказов
import contragents from './contragents' // модул дл хранения и работы с контрагентами
import directions from './directions' // модуль для хранения направлений деятельности
import users from './users'
import materials from './materials'
import quality from './quality';
import postTypes from './posttypes';
import prices from './prices';
import org from './organization';
import bills from './bills';
import charges from './charges';
import executors from './executors';
import postavshiks from './postavshiks';
import cloudUpload from './cloudUpload';
import reports from './reports'
import debit from './debit'
import userPays from './userPays'


Vue.use(Vuex); 



// axios.defaults.baseURL = "http://adm4.ru/api";
// axios.defaults.baseURL = "http://newBack.ru/api";

axios.defaults.baseURL = "https://bkmgn.advimatic.ru/api";



export const store = new Vuex.Store({
    
    state: {
        token           : localStorage.getItem('access_token') ||null,
        loginUser       : localStorage.getItem('loginUser') || null,
        // ds              : ds('37.139.33.94:6020/deepstream-v3'),
        ds              : new DeepstreamClient.DeepstreamClient('wss://advamatic.wideside.ru:9090/deepstream'),
        permissions     : localStorage.getItem('permissions') || [],
        loginUserInfo   : localStorage.getItem('loginUserInfo') || null,
        myCompany       : null,
    },

    modules : {

        ordersList,
        contragents,
        users,
        directions,
        materials,
        quality,
        postTypes,
        prices,
        org,
        bills,
        charges,
        executors,
        postavshiks,
        cloudUpload,
        reports,
        debit,
        userPays,

    },

    // plugins: [dsManager],

    getters:{
      
      getMyCompany(state) {
        return state.myCompany;
      },

      ds(state) {
        return state.ds;
      },

      loggedIn(state) {
        return state.token != null;
      }, 
      
      loginUserInfo(state) {
        return state.loginUserInfo;
      },

      getLoginUser(state) {
        return state.loginUser;
      },

      getPermissions(state) {
          return state.permissions;
      },

      isAllowPermission: (state) => (permission) => {
        let q = state.permissions;
        if (q.length == 0) { // если разрешения не заданы - то читаем их из базы
            let promQ = localStorage.getItem('permissions');
            if (promQ !=undefined) q = JSON.parse(promQ);
        }
        if (q == undefined) return false;
        // console.log(q+' = '+permission);

        return ((q.indexOf('*')>-1)||(q.indexOf(permission)>-1));
      }

    },

    mutations: {

        clearAllData(rootstate) {

            rootstate.loginUser = '';
            rootstate.loginUserInfo = '';
            rootstate.org.organization = [];
            rootstate.myCompany = null;
            rootstate.materials.materials = [];
            rootstate.materials.nomeklatura = [];
            rootstate.users._users = [];
            rootstate.postavshiks.postavshiks = [];
            rootstate.prices.price = [];
            rootstate.prices.prices = [];
            rootstate._order = [];
        },

        setMyCompany(state, data) {
            state.myCompany = data;
        },

        setLoginUserInfo(state, data) {
            localStorage.setItem('loginUserInfo', data);
            state.loginUserInfo = data;
        },

        setLoginUser(state, data) {
            state.loginUser = data;
        },
        
        retrieveToken(state, token) {
            localStorage.setItem('access_token', token);
            state.token = token;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        },

        destroyToken(state) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('permissions');
            state.token = null;
            state.permissions = [];
        },

        setPermissions(state, data) {
            state.permissions = data;
            localStorage.setItem('permissions', JSON.stringify(data));
        },  
        
    },

    actions : {
        getMyCompany(context, data) {
            return new Promise((resolve, reject) => {

                axios.get('/getMyCompany')
                .then(response => {
                    context.commit('setMyCompany', response.data);
                    resolve(response);
                })
                 .catch(error => {
                     console.log(error);
                     context.commit('setMyCompany', null);
                     reject(error);
                 });
            });
        },

        register(context, data) {
              return new Promise((resolve, reject) => {
                   axios.post('/register', {
                        name: data.name,
                        email: data.email,
                        password: data.password,
                   })
                   .then(response => {
                        resolve(response)
                   })
                   .catch(error => {
                        reject(error)
                  })
            })
        },

        destroyToken(context) {

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;

            if (context.getters.loggedIn) {

                return new Promise((resolve, reject) => {
                     
                     axios.post('/logout')

                    .then(response => {

                        context.commit('destroyToken');
                        resolve(response);

                    })
                    .catch(error => {
                        context.commit('destroyToken');
                        reject(error);

                    });
                });

            }
        },

        getPermissions(context) {
            
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
                // if (context.state.token == null) axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.oldToken;
                axios.get('/getPermissions')
                .then(response => {
                    // commit('retrieveToken', context.state.token);
                    context.commit('setPermissions', response.data);
                    resolve(response);
                })
                 .catch(error => {
                     console.log(error);
                     context.commit('setPermissions', []);
                     reject(error);
                 });
            });

        },

        retrieveToken({commit, dispatch}, credentials) {

            return new Promise((resolve, reject) => {
               
                axios.post('/login', {
                    username : credentials.username,
                    password : credentials.password,
                })
                .then(response => {

                    const token = response.data.access_token;
                    const userId = response.data.id;
                    localStorage.setItem('loginUser',response.data.name+' '+response.data.surname);
                    commit('retrieveToken', token);
                    commit('setLoginUser', response.data.name+' '+response.data.surname);
                    commit('setLoginUserInfo', response.data);
                    commit('setPermissions', response.data.permissions);

                    resolve(response);

                })
                 .catch(error => {
                     console.log(error);
                     reject(error);
                 });
            });
        },

    }



})